export function CeleroManualPaymentCtrl (
  $uibModalInstance,
  $scope,
  celero,
  invoice,
  payment,
  ) {
  $scope.celero  = celero;
  $scope.invoice = invoice;
  $scope.payment = payment;

  $scope.submit = function () {
    $scope.$broadcast('celeroSubmit');
  };

  $scope.$on('celeroSuccess', () => {
    $uibModalInstance.close();
  });
}
